import { atom } from "jotai";

// Mobile sheet visibility. The desktop sidebar is always visible at md+,
// so it doesn't need an atom — these only gate the mobile slide-up sheets.
export const isSortSheetOpenAtom = atom(false);
export const isFilterSheetOpenAtom = atom(false);
